<template>
  <div id="app" :class="[locale == 'HE' ? 'rtl':'',!user ? 'logged-out' : '']">
    <div class="progress" v-if="showLoadingLayer">
      <div class="inner">
            <preloader></preloader>
      </div>
    </div>

    <!-- <router-link v-if="!user" class="logo mt-s ml-s" to="/">
      <img src="/img/logo.jpg" alt="" />
    </router-link> -->
    <transition name="fade-appear" appear>
      <top-bar v-if="showTopBar" />
    </transition>
    <!-- <top-bar v-if="user" /> -->
    <keep-alive include="Login">
      <router-view />
    </keep-alive>
    <transition name="fade" appear>
      <site-footer v-if="showFooter"></site-footer>
    </transition>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import TopBar                   from "@/components/TopBar.vue";
  import SiteFooter               from "@/components/SiteFooter.vue";
  import ProgressCircle from "@/components/ProgressCircle.vue";

  //App.vue code
  //import  {validate}  from "@/mixins/validations.js";
  //import  notifications  from "@/mixins/notifications.js";

  export default {
  //mixins: [validate,notifications],

  data() {
    return {
      showFooter: false,
      notifications_interval: null
    };
  },
  components: {
    TopBar,
    SiteFooter,ProgressCircle
  },
  watch: {
    user() 
    {
      var vm = this;
      console.log("user changed>> ", this.user);
      if (this.user) 
      {
        vm.initOrdersList();
        vm.loadNotifications();
        //this.sbClientStartListen();//START SERVICEBUS LISTENER        
        if(vm.notifications_interval==null){
            vm.notifications_interval = setInterval(() => {              
              vm.loadNotifications();// LOAD NOTIFICATIONS FROM STORE EVERY 5 MIN
            }, 300000);          
        }
      }
    },
    $route() {
      // console.log("route chamged...");
      this.showFooter = false;
      if (this.$route.name === "Home") {
        setTimeout(
          function() {
            this.showFooter = true;
          }.bind(this),
          1300
        );
      }
    }
  },
  created() {
    this.initLocale();
    this.initUser();
    if (this.user) 
    {
      this.initOrdersList();
      this.sbClientStartListen();//START SERVICEBUS LISTENER
      this.loadNotifications();//LOAD NOTIFICATIONS FROM STORE
    }
  },
  mounted() {
    window.addEventListener("resize", this.resizeHandler, false);
    this.updateDevice();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler, false);
  },
  methods: {
    ...mapActions(["initUser", "initOrdersList", "updateDevice","loadNotifications","setLocale"]),
    resizeHandler() {
      console.log("resizeHandler");
      this.updateDevice();
    },
    initLocale() {
      let localeFromStorage = localStorage.getItem("MIS-locale");//storage.get(`MIS-locale`, localStorage);
      if (localeFromStorage) {
        this.setLocale(localeFromStorage);
      } else {
        this.setLocale('en');
      }
    },    
  },
  computed: {
    ...mapState(["user", "order", "showTopBar","locale","localizedUI","showLoadingLayer"])
    // showFooter() {
    //   return (
    //     this.$route.name === "Home" || (this.order && this.order.data.Order)
    //   );
    // }
  }
};
</script>
<style lang="stylus">

#app
  // height 100%
  & > .logo
    display block
    max-width 220px
    +below(815px)
      max-width 120px
    img
      width 100%
  &.rtl
    direction rtl
.logged-out
  background #fff
  pad('2xl', bottom)
  +below(815px)
    overflow hidden
    position relative
    height 100vh
    padding-bottom 0
  // background linear-gradient(95deg, #1db0a1 0%, #008996 100%)
</style>

<style scoped>
  .progress
  {
    width: 100%;
    height: 100vh;
    background-color: rgba(255,255,255,0.8);    
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
  }
  .progress .inner
  {
    position: relative;
    top:50%;
    left: 50%;
    transform: translate(-50%,-50%);
    color:#000;
    text-align: center;
    font-size: 30px;
  }
</style>

<!--
      {% if section.settings.view-btn != blank %}
      <button class="button outline navigable ">
	      <a href="{{ section.settings.view-btn-link }}">{{ section.settings.view-btn }}</a>
      </button>
      {% endif %}



  .textOnBg
  {
    background-color:#000;
    background-size: cover;  
    bacground-position: center;
    text-align:center;
    width:100%;
    height:100vh;
    clear:both;  
    position:relative;
  }
.tobInner{
    position: relative;
	    top:0;
      left: 0;
    width:100%;
    height:100vh;
    background-color:rgba(0,0,0,0.6);	  
}
  .tobContent {
    position: absolute;
    top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      color:#fff;
      text-align: center;
      font-size: 30px;  
  }
  .tobInner h2{
      font-size: 48px;
      font-family: Montserrat, sans-serif;
      font-style: normal;
      font-weight: 400;    
  }
  .tobInner .discription{
    font-family: "Source Sans Pro", sans-serif;
    font-style: normal;
    font-weight: 300;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 18px;
    line-height: 28px;
  }
	.tobInner .button
{
  margin-top:30px;
}




-->
